This field is deprecated and must be omitted from all inputs.

Do not explicitly set to `null` or any other value.
